// extracted by mini-css-extract-plugin
module.exports = {"dark":"i_CP","light":"i_CQ","container":"i_CR","image":"i_CS","overlay":"i_CT","icon":"i_CU"};